module.exports = __webpack_public_path__ + "img/down-purple.f9093f72.svg";